import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from '@mui/icons-material/Remove';

const ReduceOptionPopup = ({ open, onClose, productVariants, onReduce }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden" } }}
      BackdropProps={{ sx: { backdropFilter: "blur(6px)" } }}
    >
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        sx={{ position: "absolute", right: 12, top: 12, zIndex: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ padding: 2 }}>
        <Typography variant="h6" mb={2}>
          Select option to reduce
        </Typography>

        {productVariants.length === 0 ? (
          <Typography>No variants in cart.</Typography>
        ) : (
          productVariants.map((item) => {
            const qty = item.quantity || 0;
            return (
              <Box
                key={item.cartKey}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  p: 2,
                  mb: 1,
                }}
              >
                <Typography>
                  {item.product.name}{" "}
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography>{qty}</Typography>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onReduce(item.product)
                    }}
                    disabled={qty <= 0}
                  >
                    <RemoveIcon />
                  </Button>
                </Box>
              </Box>
            );
          })
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReduceOptionPopup;
